/* Attorney Feature Layout - Main page structure only

   Component-specific styles have been extracted to their own modules:
   - components/Sidebar/Sidebar.module.css
   - components/HeaderBar/HeaderBar.module.css
   - components/EntriesTable/EntriesTable.module.css
   - views/CalendarView/CalendarView.module.css
   - views/SupportView/SupportView.module.css
*/

/* ============================================
   MAIN LAYOUT WRAPPER
   ============================================ */
.reportWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  background-color: var(--secondary);
  overflow: hidden;
}

.reportWrapper.darkMode {
  background-color: var(--background);
  color: var(--foreground);
}

/* ============================================
   MAIN CONTENT AREA (right of sidebar)
   ============================================ */
.reportWholeWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  height: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  background-color: var(--background);
  padding-left: 12px;
  padding-right: 12px;
}

.darkMode .reportWholeWrapper {
  background-color: var(--background);
}

/* ============================================
   CONTENT WRAPPER (table/views container)
   ============================================ */
.reportContentWrapper {
  width: 100%;
  justify-content: start;
  align-items: stretch;
  flex-direction: column;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  margin-bottom: 12px;
  box-sizing: border-box;
  flex: 1 1 0;
  min-height: 0;
  overflow-x: auto;
  overflow-y: auto;
  display: flex;
}

.darkMode .reportContentWrapper {
  border: 1px solid var(--border);
}

/* Full-bleed variant: no border/padding for settings/support/analytics views */
.fullBleed {
  border: none;
  border-radius: 0;
  margin-left: -12px;
  margin-right: -12px;
  width: calc(100% + 24px);
}

/* ============================================
   INTERMEDIATE RESPONSIVE LAYOUT
   ============================================ */
@media screen and (max-width: 1000px) {
  .reportWholeWrapper {
    padding-left: 8px;
    padding-right: 8px;
  }

  .fullBleed {
    margin-left: -8px;
    margin-right: -8px;
    width: calc(100% + 16px);
  }
}

/* ============================================
   MOBILE RESPONSIVE LAYOUT
   ============================================ */
@media screen and (max-width: 750px) {
  /* Prevent page scrolling - fix viewport */
  :global(html),
  :global(body) {
    height: 100vh !important;
    overflow: hidden !important;
    position: fixed !important;
    width: 100% !important;
  }

  /* Mobile layout - stack sidebar on top */
  .reportWrapper {
    flex-direction: column !important;
    height: 100vh !important;
    overflow: hidden !important;
  }

  .reportWholeWrapper {
    width: 100% !important;
    order: 2;
    flex: 1;
    border-left: none !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 12px !important;
    height: calc(100vh - 50px) !important;
  }

  .reportContentWrapper {
    flex: 1 !important;
    height: auto !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    position: relative !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .fullBleed {
    margin-left: -12px;
    margin-right: -12px;
    width: calc(100% + 24px);
  }
}
